import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=deb1b2ae&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('deb1b2ae')) {
      api.createRecord('deb1b2ae', component.options)
    } else {
      api.reload('deb1b2ae', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=deb1b2ae&", function () {
      api.rerender('deb1b2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xRQKNzuFwbny/JS/comp/ImgFallback.vue"
export default component.exports